import React, { useEffect, useState } from "react";

import Preloader from "~/components/Preloader";
import InfoBlock from "~/pages/IvideonDealerSummary2/Components/InfoBlock";
import FilterSummary from "~/widgets/Filters/FilterSummary";
import {
  useGetAnalyticaReport,
  useGetVehicleAnalytics2,
} from "~/entity/Ivideon";

import ChartsCar from "./ChartsCar";
import ItemChartCar from "./ItemChartCar";
import { getCarsData, infoBlockData } from "./helper";

import styles from "~/pages/IvideonDealerSummary2/IvideonDealerSummary.less";

export interface dataBarIProps {
  newVehicles: (number | null)[];
  returningVehicles: (number | null)[];
  totalVehicles: (number | null)[];
  uniqueVehicles: (number | null)[];
}

export type LabelsType = string[] | string[][];

const CarSummary = () => {
  const [variant, setVariant] = useState<string | null>(null);

  const [labels, setLabels] = useState<LabelsType>([]);
  const [dataBar, setDataBar] = useState<dataBarIProps | null>(null);
  const { data, isLoading, setParamsFilter, dates } = useGetVehicleAnalytics2();

  const { getAnalyticsReport } = useGetAnalyticaReport();

  const handleVariant = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = (e.target as HTMLElement).closest(
      "[data-variant]",
    ) as HTMLDivElement;
    if (!target) return;

    const nextVariant = target.dataset.variant ?? null;

    setVariant((prevVariant) => {
      return prevVariant === nextVariant ? null : nextVariant;
    });
  };

  useEffect(() => {
    if (data && dates) {
      const { startDate, endDate } = dates;

      getCarsData({
        startDate,
        endDate,
        data,
        variant,
        setDataBar,
        setLabels,
      });
    }
  }, [dates, data, variant]);

  return (
    <>
      <FilterSummary
        setParamsFilter={setParamsFilter}
        getAnalyticsReport={getAnalyticsReport}
        type="cars"
      />
      {!isLoading && data && dataBar ? (
        <>
          <div className={styles.wrapper_content_total} onClick={handleVariant}>
            <InfoBlock
              results={infoBlockData(data)}
              variant={variant}
              switcher={true}
            />
          </div>
          <div className={styles.wrapperGraph}>
            {variant ? (
              <ItemChartCar
                isLoading={isLoading}
                dataBar={dataBar!}
                labels={labels}
                variant={variant}
                handleVariant={setVariant}
              />
            ) : (
              <ChartsCar
                dataBar={dataBar}
                isLoading={isLoading}
                labels={labels}
                handleVariant={setVariant}
              />
            )}
          </div>
        </>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default CarSummary;
